import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/bell/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/bell/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/bell/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconBell24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Bell`, id: 'icon.title.bell', comment: 'Title for bell icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-bell-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.01 21.782a2.11 2.11 0 0 0 1.992 1.467c.905 0 1.725-.605 1.993-1.467M12 3V.75M12 3c4.168 0 7.5 3.492 7.5 7.619C19.5 17.777 21 19 21 19H3s1.5-1.946 1.5-8.381C4.5 6.519 7.865 3 12 3"></path></svg>`; }
}
if (!customElements.get('w-icon-bell-24')) {
  customElements.define('w-icon-bell-24', IconBell24);
}